module.exports = __webpack_public_path__ + "img/sciencepage5.fddb6113.png";